<button 
  [disabled]="disabled"
  [ngClass]="currentClasses" 
>
  <ng-content></ng-content>
</button>
